import { defineMessages } from 'react-intl';

import type { Props as MoreAboutProps } from '#src/components/seo/MoreAbout/index.tsx';
import { MoreAbout } from '#src/components/seo/MoreAbout/index.tsx';
import { useIntlContext } from '#src/contexts/intl/index.ts';

const messages = defineMessages({
  whenFounded: {
    defaultMessage: 'When was {displayName} founded?',
  },
  whenFoundedAnswer: {
    defaultMessage: '{displayName} was founded in {founded}.',
  },
  whoManager: {
    defaultMessage: 'Who is {displayName} manager?',
  },
  whoManagerAnswer: {
    defaultMessage: '{displayName} manager is {manager}.',
  },
});

type Props = {
  displayName: string;
  founded?: string | null;
  manager?: string;
  specificItems?: MoreAboutProps['items'];
};

export const MoreAboutTeam = ({
  displayName,
  founded,
  manager,
  specificItems,
}: Props) => {
  const { formatMessage } = useIntlContext();
  return (
    <MoreAbout
      displayName={displayName}
      items={[
        !!manager && {
          question: formatMessage(messages.whoManager, { displayName }),
          answer: formatMessage(messages.whoManagerAnswer, {
            displayName,
            manager,
          }),
        },
        !!founded && {
          question: formatMessage(messages.whenFounded, { displayName }),
          answer: formatMessage(messages.whenFoundedAnswer, {
            displayName,
            founded,
          }),
        },
        ...(specificItems || []),
      ].filter(Boolean)}
    />
  );
};
